import { Component } from '@angular/core';
import { WizardService } from '@sondermind/flows-host';

@Component({
  selector: 'flows-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent {
  constructor(
    public wizardSvc: WizardService,
  ) { }

  completed$ = this.wizardSvc.completed$;

  toggleFlow() {
    this.wizardSvc.toggleRunning();
    this.wizardSvc.setFlowContainer();
  }
}
